import styled from "styled-components"

export const EspecialidadesDestacadasAreaWrapper = styled.div`
  background-color: #fff;
`
